import { Information, Search } from '@carbon/react/icons';
import { Button, IconButton, Modal } from '@carbon/react';
import { ReactNode, useReducer } from 'react';

import style from './documents-search.module.scss';

const Tip = ({ title, children }: { title: string; children: ReactNode }) => {
  return (
    <>
      <dt>
        <Search />
        {title}
      </dt>
      <dd>{children}</dd>
    </>
  );
};

// iconOnly renders the trigger as a ghost icon button, to sit among icon controls.
const SearchTips = ({ iconOnly = false }: { iconOnly?: boolean }) => {
  const [open, toggleOpen] = useReducer((s) => !s, false);
  return (
    <>
      <Modal
        modalHeading="Insights Search Tips"
        passiveModal={true}
        size="sm"
        onRequestClose={toggleOpen}
        open={open}
        className={style.searchTips}
      >
        <p>
          Search covers document fields, interpretations, and the full OCR body
          text, and is case-insensitive. Combine keywords and operators to
          refine results:
        </p>

        <dl>
          <Tip title="Expedition Royalty">
            Either term — &quot;Expedition&quot; or &quot;Royalty&quot;, or
            both.
          </Tip>
          <Tip title='"Expedition Royalty"'>
            Quotation marks match the exact phrase, in that order.
          </Tip>
          <Tip title="Expedition + Royalty">Both terms must appear.</Tip>
          <Tip title="Expedition + (Royalty Pontiac)">
            &quot;Expedition&quot; and either &quot;Royalty&quot; or
            &quot;Pontiac&quot;.
          </Tip>
          <Tip title="Expedition + -Royalty">
            &quot;Expedition&quot; but not &quot;Royalty&quot;. The minus sign
            must sit against the word it excludes — no space.
          </Tip>
          <Tip title="Mineral~1">
            Allows one character to differ, to catch an OCR misread like
            &quot;minerai&quot;. Put ~1 right after the word.
          </Tip>
        </dl>
      </Modal>
      {iconOnly ? (
        <IconButton
          kind="ghost"
          label="Search tips"
          size="md"
          align="bottom"
          autoAlign
          onClick={() => toggleOpen()}
        >
          <Information />
        </IconButton>
      ) : (
        <Button
          kind="ghost"
          size="md"
          className={style.tips}
          onClick={() => toggleOpen()}
        >
          Search Tips
        </Button>
      )}
    </>
  );
};

export { SearchTips };
